import React from 'react';

const CategoriesPage = () => {
  return (
    <div>
      Categories to be listed here.
    </div>
  );
};

export default CategoriesPage;